<template>
  <div id="app">
    <template v-if="!isLoginPath">
      <div class="home-tabs">
        <div class="home-title">
          <img src="@/assets/images/homePage/logo.png" alt="" />
          <p><span>金融科技实践虚拟仿真</span><span>教学实验平台</span></p>
        </div>
        <div class="home-btn">
          <img src="@/assets/images/homePage/scale.png" @click="toggleFullScreen" alt="" />
          <div class="quit" v-if="!isLogin" @click="quit" v-loading.fullscreen.lock="fullscreenLoading">
            退出
          </div>
          <div class="login-btn" @click="goRouter('/login')" v-if="isLogin">
            <span>登录</span>
            <i>|</i>
            <span>注册</span>
          </div>
        </div>
      </div>
      <div class="home-container">
        <div class="home-container-tabs">
          <div class="userInfo" @click="goRouter('/userInfo')">
            <img v-if="!isLogin" :src="userInfo.portraitUrl" alt="" />
            <img v-if="isLogin" src="@/assets/images/homePage/tourist.png" alt="" />
            <template>
              <h4 v-if="!isLogin">{{ userInfo.name || userInfo.userName }}</h4>
              <h4 v-else>游客</h4>
            </template>

            <template>
              <h5 v-if="isRegistSchool && !isLogin" :title="`${userInfo.schoolName} | ${userInfo.collegeName}`">
                {{ userInfo.schoolName }} | {{ userInfo.collegeName }}
              </h5>
              <h5 v-if="!isLogin && !isRegistSchool">您还未注册高校</h5>
            </template>
            <div class="settings">
              <settings></settings>
            </div>
          </div>
          <div class="home-container-tabs-list">
            <div class="list" :class="active == index ? 'tabsActive' : ''" v-for="(item, index) in tabsList"
              :key="item.title">
              <img :src="item.img" alt="" v-if="active != index" />
              <img :src="item.imgActive" alt="" v-if="active == index" />
              <span @click="goRouter(item.path, index)">{{ item.title }}</span>
            </div>
          </div>
        </div>
        <div class="home-container-content"><router-view></router-view></div>
      </div>
    </template>
    <template v-else><router-view></router-view></template>
  </div>
</template>
<script>
import settings from "@/components/svg/settings.vue";
import logout from "@/assets/mix/logout.js";
import { mapState } from "vuex";
export default {
  name: "VirtualimitationAbout",
  components: { settings },
  mixins: [logout],
  data () {
    return {
      active: -1,
      isLoginPath: false,
      isLogin: true, //是否登录
      islogonTimer: null,
      logonTimerFlag: true,
      userInfo: {},
      tabsList: [],
      touristList: [
        {
          title: "实验中心",
          img: require("@/assets/images/homePage/experimentalCenter.png"),
          imgActive: require("@/assets/images/homePage/experimentalCenter-active.png"),
          path: "/experimentalCenter",
        },
        {
          title: "我的实验",
          img: require("@/assets/images/homePage/myExperiment.png"),
          imgActive: require("@/assets/images/homePage/myExperiment-active.png"),
          path: "/myExperiment",
        },
        {
          title: "消息中心",
          img: require("@/assets/images/homePage/news.png"),
          imgActive: require("@/assets/images/homePage/news-active.png"),
          path: "/news",
        },
      ],
      teacherTab: [
        {
          title: "实验列表",
          img: require("@/assets/images/homePage/experiment.png"),
          imgActive: require("@/assets/images/homePage/experiment-active.png"),
          path: "/experimentList",
        },
        {
          title: "消息中心",
          img: require("@/assets/images/homePage/news.png"),
          imgActive: require("@/assets/images/homePage/news-active.png"),
          path: "/news",
        },
      ],
      studentTab: [
        {
          title: "实验中心",
          img: require("@/assets/images/homePage/experimentalCenter.png"),
          imgActive: require("@/assets/images/homePage/experimentalCenter-active.png"),
          path: "/experimentalCenter",
        },
        {
          title: "我的高校",
          img: require("@/assets/images/homePage/myCollege.png"),
          imgActive: require("@/assets/images/homePage/myCollege-active.png"),
          path: "/myCollege",
        },
        {
          title: "我的实验",
          img: require("@/assets/images/homePage/myExperiment.png"),
          imgActive: require("@/assets/images/homePage/myExperiment-active.png"),
          path: "/myExperiment",
        },
        {
          title: "消息中心",
          img: require("@/assets/images/homePage/news.png"),
          imgActive: require("@/assets/images/homePage/news-active.png"),
          path: "/news",
        },
      ],
      isRegistSchool: false, //是否注册高校
      num: 0, //记录次数
      fullscreenLoading: false,
    };
  },
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (
          oldVal &&
          newVal.path == "/experimentListDetail" &&
          oldVal.path != "/"
        ) {
          // newVal.query.name = oldVal.name;
          let preRouter = {
            name: oldVal.name,
            path: oldVal.path,
          };
          sessionStorage.setItem("preRouter", JSON.stringify(preRouter));
        }
        if (newVal.path != "/experimentListDetail" && newVal.path != "/") {
          sessionStorage.removeItem("preRouter");
        }
        if (newVal.path == "/login") {
          this.num = 0;
          this.isLoginPath = true;
        } else {
          this.isLoginPath = false;
          this.num = this.num + 1;
          if (this.num == 1) {
            this.$store.commit("iS_LOGIN", this.callback);
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(["user", "token"]),
  },

  mounted () {
    this.init()
  },

  methods: {
    callback (flag) {
      this.isLogin = !flag;
      if (flag) {
        //登录了之后才会做轮询请求
        this.$nextTick(() => {
          this.init();
          this.loginInit();
        });
      } else {
        this.tabsList = this.touristList;
        this.active = 0;
      }
    },
    //获取用户信息
    getUserInfoLogin () {
      // let params = {
      //   schoolId: 0,
      //   type: localStorage.getItem("type"),
      // };
      this.$api.common.getUserInfoLogin().then((res) => {
        if (res.errCode == 0 && res.data != null) {
          this.$store.commit("SET_USER", res.data);
          this.isRegistSchool = true;
          this.$nextTick(() => {
            this.userInfo = JSON.parse(localStorage.getItem("USER"));
            if (this.userInfo.type == 2) {
              //学生
              this.tabsList = this.studentTab;
            } else if (this.userInfo.type == 1) {
              //教师
              let obj = {
                title: "学院管理",
                img: require("@/assets/images/homePage/college.png"),
                imgActive: require("@/assets/images/homePage/college-active.png"),
                path: "/college",
              };
              // 教师管理员2, 1为普通用户
              if (res.data.role == 2) {
                this.tabsList = [...this.teacherTab, obj];
                return;
              }
              this.tabsList = this.teacherTab;
            }
            setTimeout(() => {
              this.tabsList.forEach((item, index) => {
                if (item.path == this.$route.path) {
                  this.active = index;
                }
              });
            }, 300);
          });
        } else {
          //如果没有返回则说明是登录成功了，但是没有注册高校  继续显示对应的tab栏，不过不可以操作    ？？？？？？？？？？？？？？？等会做
          this.userInfo = this.$store.state.user;
          this.isRegistSchool = false;
          if (localStorage.getItem("type") == 2) {
            this.tabsList = this.studentTab;
            this.$router.replace("/experimentalCenter");
            this.$message.error("您还未在高校注册！");
          } else if (localStorage.getItem("type") == 1) {
            this.tabsList = this.teacherTab;
            this.$router.replace("/experimentList");
            this.$message.error("您还未在高校注册！");
          } else {
            this.tabsList = this.touristList;
            this.$router.replace("/experimentalCenter");
          }
          this.active = 0;
        }
      });
    },
    //登录轮询请求   更新token token15分钟会自动刷新一次
    loginInit () {
      //避免路由重定向的时候，调用了两次loginInit。从而产生两个定时器
      this.getUserInfoLogin();
      if (!this.logonTimerFlag) {
        return;
      }
      this.logonTimerFlag = false;
      this.islogonTimer = setInterval(() => {
        // if (this.token) {
        let tokens = "";
        this.$api.auth.IsLogin(tokens)
          .then((res) => {
            if (res.errCode === 3) {
              this.$alert(res.errMsg.trim(), "登录提示", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$store.commit("SET_LOGOUT");
                  this.$router.push("/login");
                },
              });
            } else if (res.errCode === 1) {
              this.$store.commit("SET_LOGOUT");
              this.$router.push("/login");
            } else if (res.errCode === 0) {
              this.$store.dispatch("getUserInfo", JSON.stringify(res.data));
              this.isLogin = false
              this.$forceUpdate()
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("SET_LOGOUT");
            this.$router.push("/login");
          });
        // }
      }, 1000 * 60); //* 60
    },
    init () {
      // 记住登录状态和用户信息
      var params = window.location.search.split("=");
      var token = params.find((item) => item == "token");
      if (!token) {
        token = "";
      }
      this.$api.auth.IsLogin(token).then(
        (res) => {
          if (res.errCode === 0) {
            this.$util.cookie.setCookie("dqtoken", JSON.stringify(res.data));
            this.$store.commit("SET_TOKEN", res.data);
            this.$store.dispatch("getUserInfo", JSON.stringify(res.data));
            this.isLogin = false
            this.$forceUpdate()
          } else if (res.errCode === 3) {
            this.$alert(res.errMsg.trim(), "登录提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$store.commit("SET_LOGOUT");
                // this.$router.push("/login");
              },
            });
          } else {
            localStorage.removeItem("USER");
            this.$store.commit("SET_LOGOUT");
            // setTimeout(() => {
            //   this.$message.warning('请您先登录！')
            //   this.$router.push("/login");
            // }, 1000);
          }
          this.loginInit()
        },
        () => {
          this.$store.commit("SET_LOGOUT");
          localStorage.removeItem("USER");
          // this.$router.push("/login");
        }
      );
    },
    //退出登录
    quit () {
      this.fullscreenLoading = true;
      // this.handleSpinCustom();
      setTimeout(() => {
        this.fullscreenLoading = false;
        // this.$store.commit("iS_LOGIN", this.callback);
        // if (this.$route.path != "/experimentalCenter") {
        //   this.$router.push("/experimentalCenter");
        // }
        // this.$message({
        //   message: "退出登录成功",
        //   type: "success",
        // });

        this.$api.auth.Logout().then(res => {
          localStorage.removeItem("USER");
          this.$store.commit("SET_LOGOUT");
          this.$router.push("/login");
        });
      }, 2000);
    },
    //路由跳转
    goRouter (path, index) {
      if (path != "/login") {
        if (path == "/experimentalCenter") {
          this.active = 0;
          this.$router.replace(path).catch((err) => err);
          return;
        }
        if (this.isLogin) {
          this.$message({
            message: "您还未登录,请先登录！",
            type: "warning",
          });
          return;
        }
        if (
          !this.isRegistSchool &&
          path != "/experimentalCenter" &&
          path != "/myExperiment"
        ) {
          this.$message({
            message: "您还未注册高校！",
            type: "warning",
          });
          return;
        }
      }

      if (index != undefined || index == 0) {
        this.active = index;
      } else {
        this.active = -1;
      }
      if (path == "/userInfo" && !localStorage.getItem("USER")) {
        this.$message({
          message: "您还未登录",
          type: "warning",
        });
        return;
      }
      this.$router.replace(path).catch((err) => err);
    },
    //全屏
    toggleFullScreen () {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
  beforeDestroy () {
    console.log("销毁");
    // 轮询登录
    clearInterval(this.islogonTimer);
  },
};
</script>
<style lang="less">
#app {
  max-width: 1900px;
  min-width: 1900px;
  // min-height: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  // overflow: hidden;
  .home-container {
    flex: 1;
    display: flex;
    justify-content: start;
    background: #f6f7fb;

    .home-container-tabs {
      width: 290px;
      background: #fff;

      .userInfo {
        width: 290px;
        height: 212px;
        padding: 40px 0 33px 0;
        border-top: 1px solid #eef2fa;
        border-bottom: 1px solid #eef2fa;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;

        .settings {
          width: 32px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 24px;
          right: 26px;
          background: rgba(55, 82, 212, 0.04);
          border-radius: 50%;
        }

        img {
          width: 70px;
          height: 70px;
          display: block;
          margin: 0 auto;
          border-radius: 50%;
        }

        h4 {
          font-size: 16px;
          font-family: PingFang-SC;
          font-weight: 500;
          line-height: 22px;
          color: #424346;
          margin: 10px 0 8px 0;
          text-align: center;
        }

        h5 {
          font-size: 12px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 17px;
          color: #8e8e90;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }

      .home-container-tabs-list {
        width: 290px;
        padding: 26px;
        box-sizing: border-box;

        .list {
          width: 237px;
          height: 42px;
          background: #fff;
          border-radius: 4px;
          padding-left: 26px;
          box-sizing: border-box;
          display: flex;
          justify-content: start;
          align-items: center;

          span {
            display: inline-block;
            margin-left: 9px;
            font-size: 14px;
            font-family: PingFang-SC;
            font-weight: 500;
            line-height: 20px;
            color: #424346;
            opacity: 0.92;
            cursor: pointer;
          }
        }
      }
    }

    .home-container-content {
      // flex: 1;
      width: 1610px;
      height: 887px;
      min-height: 100%;
      overflow-y: auto;
      background: #f6f7fb;
      padding: 28px 12px 28px 24px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0);
        box-shadow: inset 0 0 4px rgba(255, 255, 255, 0.65);
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0);
        box-shadow: inset 0 0 4px rgba(255, 255, 255, 0.65);
      }
    }
  }

  .home-tabs {
    width: 1900px;
    //  min-width: 1920px;
    height: 82px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    box-shadow: 0px 3px 15px rgba(23, 26, 95, 0.08);
    box-sizing: border-box;

    .home-title {
      width: 290px;
      height: 82px;
      border-right: 1px solid #eef2fa;
      border-bottom: 1px solid #eef2fa;
      display: flex;
      justify-content: start;
      align-items: center;

      img {
        width: 50px;
        height: 50px;
        margin-left: 20px;
      }

      p {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
      }

      span {
        font-size: 20px;
        font-family: PingFang-SC;
        font-weight: 600;
        line-height: 28px;
        color: #1880fa;
        opacity: 1;
        // margin-left: 20px;
      }
    }

    .home-btn {
      width: 200px;
      height: 82px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .login-btn {
        display: flex;
        justify-content: start;
        align-items: center;
        margin-right: 26px;

        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #1880fa;
          cursor: pointer;
        }

        i {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #99a7c3;
          margin: 0 10px;
          font-style: normal;
        }
      }

      img {
        width: 17.5px;
        height: 17.5px;
      }

      .quit {
        width: 65px;
        height: 32px;
        background: #e8effd;
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 32px;
        color: #1880fa;
        text-align: center;
        margin-right: 25px;
        cursor: pointer;
      }
    }
  }
}

.tabsActive {
  background: #1880fa !important;

  i,
  span {
    color: #fff !important;
  }
}

html,
body {
  height: 100%;
  box-sizing: border-box;
}

.el-table .cell {
  font-family: PingFang-SC;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>
